import { useState } from 'react';
import { ChevronDown, ChevronUp, Edit, Trash2 } from 'lucide-react';
import {
  Box,
  Collapse,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';

import { CourseLevel } from '../../types/CourseStageAccordion.type';
import CourseStageList from './CourseStageList';
import { Subtype } from '../../types/ServiceAccordion.type';
import TreeBranch, { treeItemSx } from '../common/TreeBranch';

interface CourseLevelCardProps {
  courseType: Subtype;
  level: CourseLevel;
  onEdit: (service: CourseLevel) => void;
  onDelete: (service: CourseLevel) => void;
  fetchCourses: () => void;
}

const CourseLevelCard: React.FC<CourseLevelCardProps> = ({
  courseType,
  level,
  onEdit,
  onDelete,
  fetchCourses,
}) => {
  const [open, setOpen] = useState(false);

  const handleToggle = () => {
    setOpen(!open);
  };

  return (
    <>
      <ListItem
        disablePadding
        secondaryAction={
          <Box sx={{ display: 'flex', alignItems: 'center', mr: 10 }}>
            <IconButton
              edge="end"
              aria-label="edit"
              onClick={() => onEdit(level)}
              sx={{ mr: 1 }}
            >
              <Edit size={18} />
            </IconButton>
            <IconButton
              edge="end"
              aria-label="delete"
              onClick={() => onDelete(level)}
            >
              <Trash2 size={18} />
            </IconButton>
          </Box>
        }
        sx={[
          {
            mb: 2,
            backgroundColor: 'background.paper',
            borderRadius: 1,
            boxShadow: 1,
            '&:hover': {
              backgroundColor: 'action.hover',
            },
          },
          treeItemSx,
        ]}
      >
        <ListItemButton onClick={handleToggle} dense>
          <ListItemText
            primary={
              <Typography variant="body1" component="div" fontWeight="medium">
                {level.levelName}
              </Typography>
            }
          />
          {open ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
        </ListItemButton>
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <TreeBranch>
          <CourseStageList
            courseType={courseType}
            level={level}
            stages={level.stages || []}
            fetchCourses={fetchCourses}
          />
        </TreeBranch>
      </Collapse>
    </>
  );
};

export default CourseLevelCard;
